import { Browser } from "../../core/browser";
import { AuxiliumComponent } from "../auxilium-component";

export class MenuItem extends AuxiliumComponent {
	static observedAttributes = ["suffix-icon"];

	constructor() {
		super();

		this.icon = this.getAttribute("icon") ?? "";
		this.link = this.getAttribute("link") ?? "";
		this.detached = this.hasAttribute("detached");
		this.target = this.getAttribute("target");
		this.keepOpen = this.hasAttribute("keep-open");
		this.suffixIcon = this.getAttribute("suffix-icon") ?? "";
	}

	parsedCallback() {
		if (this.querySelector("chip-menuitem, chip-menudivider")) {
			this.appendChild(document.createElementWithContents("chip-contextmenu", [...this.children].filter(x => x.matches?.("chip-menuitem, chip-menudivider"))));
		}

		this.onmouseover = ev => {
			ev.stopPropagation();
			this.#HandleMouseOver(ev);
		}

		let elementName = this.link ? "a" : "button";
		if (this.detached) { elementName = "span"; }

		const button = document.createElementWithContents(elementName, [...this.childNodes].filter(x => !x.matches?.("chip-contextmenu")), {
			className: "context-menu-item-btn"
		});

		if (this.link) {
			button.href = Browser.ResolveRelativeURL(this.link);

			if (this.target) {
				button.target = this.target;
			}
		} else if (!this.detached) {
			button.type = "button";
		}

		if (this.icon) {
			button.prepend(document.createElementWithContents("chip-icon", null, {
				icon: this.icon
			}));
		}

		if (this.suffixIcon) { button.appendChild(document.createElementWithContents("chip-icon", null, { icon: this.suffixIcon, className: "menu-item__suffix-icon" })); }

		this.removeEventListener("click", this.#HandleClick);
		this.addEventListener("click", this.#HandleClick);

		this.prepend(button);
	}

	#HandleClick() {
		if (!this.keepOpen && !this.closest("li")?.classList.contains("context-sub-menu-item")) {
			this.closest("chip-contextmenu")?.Close();
		}
	}

	#HandleMouseOver(ev) {
		if (ev.target?.nodeName === "UL" || ev.target?.closest("chip-menudivider")) { return; }

		const menu = this.querySelector("ul"),
			subItem = this.closest(".context-sub-menu-item") ?? this;

		[...this.closest("ul").querySelectorAll(".context-sub-menu-item.show")].filter(x => !x.contains(subItem)).forEach(x => x.classList.remove("show"));

		if (menu && subItem && window.getComputedStyle(menu).opacity === "0") {
			Object.assign(menu.style, {
				top: "calc(var(--block-size-sm) * -1)",
				left: "99%"
			});

			const { width, right, bottom } = menu.getBoundingClientRect();

			//The +15 here is because we animate a translation of 15px when showing a menu
			const heightDiff = bottom - (document.body.clientHeight - 5 + 15);
			menu.style.top = heightDiff > 0 ? `-${heightDiff}px` : "calc(var(--block-size-sm) * -1)";

			if (right - (document.body.clientWidth - 5 + 15) > 0) {
				menu.style.left = `-${width}px`;
			}

			subItem.classList.add("show");
		}
	}

	attributeChanged(name, _, newValue) {
		if (name === "suffix-icon") {
			this.querySelector(":scope > *> .menu-item__suffix-icon")?.remove();

			if (newValue) {
				this.firstElementChild.appendChild(document.createElementWithContents("chip-icon", null, { icon: newValue, className: "menu-item__suffix-icon" }));
			}
		}
	}
}